import { useCallback } from 'react';
import { aiAPI, parseChatJsonResponse } from '../../services/api';
import { consumeChatStream } from './chatStream';
import { insertStoppedAfterMessage } from './chatIndicatorHelpers';

export default function useAIChatStream({ setStreamingStatus, setMessages, applyChatResponse }: any) {
  const streamChatTurn = useCallback(
    async ({ payload, hadThreadId, streamMessageId, originalQuestion, abortController }) => {
      try {
        const streamRes = await aiAPI.chatStream(payload, abortController.signal);
        const contentType = streamRes.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
          const res = await parseChatJsonResponse(streamRes);
          applyChatResponse(res, {
            hadThreadId,
            replaceMessageId: streamMessageId,
            originalQuestion,
          });
          return { ok: true };
        }

        let fullReply = '';
        await consumeChatStream(streamRes, {
          onStatus: (status) => {
            setStreamingStatus(status);
          },
          onDelta: (delta) => {
            setStreamingStatus('');
            fullReply += delta;
            setMessages((prev) =>
              prev.map((m) => (m.id === streamMessageId ? { ...m, content: fullReply } : m))
            );
          },
          onDone: (data) => {
            applyChatResponse(
              {
                reply: data.reply || fullReply,
                threadId: data.threadId,
                turnId: data.turnId,
                quickActions: data.quickActions || [],
                charts: data.charts || [],
                vegaCharts: data.vegaCharts || [],
                tables: data.tables || [],
                summaries: data.summaries || [],
                questions: data.questions || [],
                scope: data.scope,
                memoryUsed: data.memoryUsed,
                ragSources: data.ragSources,
                meta: { turnId: data.turnId, ...(data.meta || {}) },
              },
              {
                hadThreadId,
                replaceMessageId: streamMessageId,
                originalQuestion,
              }
            );
          },
        });
        return { ok: true };
      } catch (streamErr: any) {
        if (streamErr?.name === 'AbortError' || abortController.signal.aborted) {
          setMessages((prev) => insertStoppedAfterMessage(prev, streamMessageId));
          return { ok: false, aborted: true };
        }
        return { ok: false, error: streamErr };
      }
    },
    [applyChatResponse, setMessages, setStreamingStatus]
  );

  return { streamChatTurn };
}
